

const MieszkaniecDaneWodaRozliczenieDokument = () => {


    return (
        <section
            style={{
                fontSize: "10px",
                padding: "15px 0",
                position: "absolute", 
                left: "50px",
                bottom: "5px"
            }}
        >
            <p
                style={{
                    textAlign: 'left'
                }}
            >
                Dokument wygenerowany elektronicznie z systemu BON Administrator. Nie wymaga podpisu.
            </p>
            <p>
                Kwotę rozliczenia należy uwzględnić w kolejnej zaliczce- dopłatę wpłacić na swój indywidualny numer rachunku bankowego,<br/>a nadpłatę odjąć od wpłaty.
            </p>
        </section>
    )
}

export default MieszkaniecDaneWodaRozliczenieDokument;